import Handler from '@/core/domain/usecase/handler';

const fetchTaskTypeRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/task-type', {
            params: pagination
        })

        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchTaskTypeRepository